import {
  Bot,
  Brain,
  Check,
  Clock,
  CreditCard,
  DollarSign,
  Download,
  Globe,
  Handshake,
  Heart,
  Link2,
  Package,
  PackagePlus,
  Percent,
  Search,
  ShieldCheck,
  ShoppingCart,
  Star,
  Store,
  Ticket,
  TrendingUp,
  Truck,
  UserCheck,
  Users,
  BarChart,
  BarChart3,
  Zap,
  type LucideIcon,
} from 'lucide-react'

export const sectionIconMap: Record<string, LucideIcon> = {
  Bot,
  Brain,
  Check,
  Clock,
  CreditCard,
  DollarSign,
  Download,
  Globe,
  Handshake,
  Heart,
  Link2,
  Package,
  PackagePlus,
  Percent,
  Search,
  ShieldCheck,
  ShoppingCart,
  Star,
  Store,
  Ticket,
  TrendingUp,
  Truck,
  UserCheck,
  Users,
  BarChart,
  BarChart3,
  Zap,
}

export type SectionIconName = keyof typeof sectionIconMap
